//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import AiCarDrawer from "./modules/AiCarDrawer";
export default {
  name: 'AiCarList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    AiCarDrawer: AiCarDrawer
  },
  data: function data() {
    return {
      pagePath: '/ai/car/push',
      pageTitle: 'AI车辆管理',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'deviceName',
        colName: 'device_id',
        title: '设备名称',
        align: 'center'
      }, {
        dataIndex: 'plateCode',
        colName: 'plate_code',
        title: '车牌号',
        align: 'center'
      }, {
        dataIndex: 'srcId',
        colName: 'src_id',
        title: '车牌照',
        align: 'center',
        scopedSlots: {
          customRender: 'avatarslot'
        }
      }, {
        dataIndex: 'aiCarType_dictText',
        colName: 'aiCarType',
        title: '车辆类型',
        align: 'center'
      }, {
        dataIndex: 'createTime',
        colName: 'create_time',
        title: '推送时间',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view/'
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      }
    };
  },
  created: function created() {},
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.queryParam.category = this.category;
      console.log(ids[1], ids[0]);

      if (ids[0] == 1) {
        // 根据站点id
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    onDate: function onDate(value, dateArray) {
      this.queryParam.sdate = dateArray[0];
      this.queryParam.edate = dateArray[1];
    },
    getAvatarView: function getAvatarView(srcId) {
      return this.url.imgerver + srcId;
    }
  }
};